import React, { useState } from 'react';
import { Modal, Button, Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FormGenerator } from '../../helper/FormGenerator';
import AuthToken from '../../utils/AuthToken';
import axios from 'axios';
import { API_URL } from '../../constants';
import { useTokens } from '../../context/TokenContext';

const EmailModal = ({ data }) => {
  const { getItem } = useTokens();
  const adminAuthToken = getItem('admin', 'AuthToken');
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [formData, setFormData] = useState({
    status: data?.status,
    subject: data?.subject || '',
    body: data?.body || '',
  });

  const [loading, setLoading] = useState(false);

  const openViewModal = (data) => {
    setModalData(data);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalData(null);
  };

  const resendEmail = async () => {
    setLoading(true);
    const token = localStorage.getItem('auth_token'); // or whatever your token key is

    try {
      const response = await axios.post(
        `${API_URL}/emails/resend/${data.id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${adminAuthToken}`,
          },
        }
      );

      toast.success(response.data.message || 'Email resent successfully');
    } catch (error) {
      toast.error(
        error.response?.data?.message || 'Failed to resend email'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button className="btn sis-button" variant="none" onClick={() => openViewModal(data)}>
        View Mail
      </Button>

      <Modal show={showModal} onHide={closeModal} size={'lg'} scrollable centered>
        <Modal.Header closeButton>
          <Modal.Title>Email Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalData ? (

            <div className='mb-1'>
              <table className='table table-bordered table-striped'>
                <tbody>
                  <tr key={data?.id}>
                    <td>To</td>
                    <td>{data?.to}</td>
                  </tr>
                  <tr key={data?.id}>
                    <td>From</td>
                    <td>{data?.from}</td>
                  </tr>
                  <tr key={data?.id}>
                    <td>Status</td>
                    <td>{data?.status}</td>
                  </tr>
                  <tr key={data?.id}>
                    <td>Sent at</td>
                    <td>{data?.sentAt}</td>
                  </tr>
                  <tr key={data?.id}>
                    <td>Subject</td>
                    <td>{data?.subject}</td>
                  </tr>
                  <tr key={data?.id}>
                    <td>Message</td>
                    <td><div dangerouslySetInnerHTML={{ __html: data?.body }}></div></td>
                  </tr>
                </tbody>
              </table>
            </div>
          ) : (
            <p>Loading data?...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary sis-button btn-sm me-2" onClick={closeModal}>Close</button>
          <button
            type="button"
            className="btn sis-button btn-sm me-2"
            onClick={resendEmail}
            disabled={loading}
          >
            {loading ? 'Resending...' : 'Resend'}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EmailModal;
